import _ from 'lodash';

export const selectPropertyWalkThroughForm = state => _.get(state, ['propertyWalkThroughForm'], {});

export const selectPropertyWalkThroughFormIsVisible = state => _.get(selectPropertyWalkThroughForm(state), ['isVisible'], false);

export const selectPropertyWalkThroughFormStep = state => _.get(selectPropertyWalkThroughForm(state), ['step'], 0);

export const selectPropertyWalkThroughFormData = state => _.get(selectPropertyWalkThroughForm(state), ['data'], {});
